export default "__VITE_ASSET__Mp9wc3C2__"